import { MainLayoutCombinedProps } from './types';

const usePresenter = (props: MainLayoutCombinedProps): MainLayoutCombinedProps => {
  return props;
};

export default usePresenter;
